// Ready-made templates the user can start from. The "current format" presets
// recreate the hard-coded backend prints so they can be edited in the builder.
import * as billing from "./billing";
import * as salesA from "./sales-a";
import * as salesB from "./sales-b";
import * as purchaseA from "./purchase-a";
import * as purchaseB from "./purchase-b";
import { normalizeTemplate } from "../schema";

const FACTORIES = [billing, salesA, salesB, purchaseA, purchaseB].flatMap((mod) =>
  Object.values(mod).filter((fn) => typeof fn === "function")
);

let cache = null;
function all() {
  if (!cache) {
    cache = FACTORIES.map((fn, i) => {
      try {
        return { key: `preset-${i}`, template: fn() };
      } catch (e) {
        console.warn("Invoice builder preset failed", fn.name, e);
        return null;
      }
    }).filter(Boolean);
  }
  return cache;
}

// Fresh copies of the presets for one document type.
export function presetsFor(docType) {
  return all()
    .filter((p) => p.template.docType === docType)
    .map((p) => ({ key: p.key, name: p.template.name, paper: p.template.paper, build: () => normalizeTemplate(JSON.parse(JSON.stringify(p.template))) }));
}
